import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { MEDGESTAO_API } from '../app.api';
import { ErrorHandler } from '../pages/app.error-handler';
import { AnexoLancamento } from '../models/anexoLancamento.model';

@Injectable()
export class AnexoLancamentoService {

  constructor(public httpClient: HttpClient) {
  }

  uploadArquivosLancamento(formData: FormData) {
    return this.httpClient.post(`${MEDGESTAO_API}/lancamento/UploadArquivoLancamento`, formData)
      .pipe(map(response => {
        return response as AnexoLancamento[];
      }, catchError(ErrorHandler.handleError)))
  }

}